var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PageHeader", {
        attrs: { title: "Unit Group: " + _vm.unitGroupName, icon: "pie_chart" },
      }),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "secondary" } },
                [_c("v-toolbar-title", [_vm._v("Unit Group Info")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs10: "",
                                md6: "",
                                "pl-3": "",
                                "pr-3": "",
                              },
                            },
                            [
                              _c(
                                "v-subheader",
                                {
                                  staticClass: "subheading primary--text",
                                  attrs: { "one-line": "" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { width: "200px" } },
                                    [_c("strong", [_vm._v("Unit Group Name:")])]
                                  ),
                                  _vm._v(" "),
                                  !_vm.isEdit
                                    ? _c("div", [
                                        _vm._v(_vm._s(_vm.unitGroupName)),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isEdit
                                    ? _c("v-text-field", {
                                        model: {
                                          value: _vm.editName,
                                          callback: function ($$v) {
                                            _vm.editName = $$v
                                          },
                                          expression: "editName",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      !_vm.isEdit
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "warning" },
                              on: {
                                click: function ($event) {
                                  return _vm.clickEditName()
                                },
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-1" }, [
                                _vm._v("edit"),
                              ]),
                              _vm._v(
                                _vm._s(_vm.$t("Button.Edit")) + "\n          "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isEdit
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "success" },
                              on: {
                                click: function ($event) {
                                  return _vm.saveEditName()
                                },
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-1" }, [
                                _vm._v("done"),
                              ]),
                              _vm._v(
                                _vm._s(_vm.$t("Button.Save")) + "\n          "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isEdit
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: {
                                click: function ($event) {
                                  _vm.isEdit = false
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", "pt-4": "" } },
            [
              _c(
                "Subheader",
                {
                  attrs: { title: "Units", search: "in List:" },
                  model: {
                    value: _vm.searchUnit,
                    callback: function ($$v) {
                      _vm.searchUnit = $$v
                    },
                    expression: "searchUnit",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success" },
                      on: {
                        click: function ($event) {
                          return _vm.clickAddUnit()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                      _vm._v(_vm._s(_vm.$t("Button.AddUnit")) + "\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c("v-data-table", {
                        attrs: {
                          headers: _vm.unitsHeaders,
                          items: _vm.unitGroup ? _vm.unitGroup.Units : [],
                          pagination: _vm.pagination,
                          search: _vm.searchUnit,
                        },
                        on: {
                          "update:pagination": function ($event) {
                            _vm.pagination = $event
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "items",
                            fn: function (props) {
                              return [
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(_vm._s(props.item.Name)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-xs-right" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { dark: "", color: "delete" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.clickRemove(props.item)
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", { staticClass: "mr-1" }, [
                                          _vm._v("delete_forever"),
                                        ]),
                                        _vm._v(
                                          _vm._s(_vm.$t("Button.Remove")) +
                                            "\n                "
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", "pt-4": "" } },
            [
              _c("Subheader", {
                attrs: { title: "Conversion Equations", search: "in List:" },
                model: {
                  value: _vm.searchConvert,
                  callback: function ($$v) {
                    _vm.searchConvert = $$v
                  },
                  expression: "searchConvert",
                },
              }),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-alert",
                        { attrs: { value: true, icon: "info", color: "info" } },
                        [
                          _vm._v(
                            "\n            Unit pairs without conversion equations are highlighted.\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-data-table", {
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.conversionInGroup,
                          search: _vm.searchConvert,
                          "hide-actions": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "items",
                            fn: function (props) {
                              return [
                                _c(
                                  "tr",
                                  {
                                    attrs: {
                                      bgcolor: _vm.getColor(props.item),
                                    },
                                  },
                                  [
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _vm._v(_vm._s(props.item.FromUnit)),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _vm._v(_vm._s(props.item.ToUnit)),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _vm._v(_vm._s(props.item.Formula)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-right" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "warning",
                                              dark: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.editConvert(
                                                  props.item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { staticClass: "mr-1" },
                                              [_vm._v("edit")]
                                            ),
                                            _vm._v(
                                              _vm._s(_vm.$t("Button.Edit")) +
                                                "\n                  "
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "800" },
              model: {
                value: _vm.addUnitDialog,
                callback: function ($$v) {
                  _vm.addUnitDialog = $$v
                },
                expression: "addUnitDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dense: "", dark: "", color: "primary" } },
                    [
                      _c("v-toolbar-title", [
                        _vm._v(_vm._s(_vm.$t("UnitGroupDetail.addTitle"))),
                      ]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", dark: "" },
                          on: {
                            click: function ($event) {
                              _vm.addUnitDialog = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "pl-3": "", "pr-3": "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Select Units",
                                  items: _vm.remainUnit,
                                  "persistent-hint": "",
                                  "item-text": "Name",
                                  "item-value": "Id",
                                  "return-object": "",
                                },
                                model: {
                                  value: _vm.addUnit,
                                  callback: function ($$v) {
                                    _vm.addUnit = $$v
                                  },
                                  expression: "addUnit",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "add", dark: "" },
                          on: {
                            click: function ($event) {
                              return _vm.addUnitToGroup()
                            },
                          },
                        },
                        [
                          _c("v-icon", [_vm._v("done")]),
                          _vm._v(
                            _vm._s(_vm.$t("Button.Save")) + "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary", outline: "" },
                          on: {
                            click: function ($event) {
                              return _vm.closeDialog()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "500" },
              model: {
                value: _vm.removeUnitDialog,
                callback: function ($$v) {
                  _vm.removeUnitDialog = $$v
                },
                expression: "removeUnitDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dense: "", dark: "", color: "primary" } },
                    [
                      _c("v-toolbar-title", [
                        _vm._v(_vm._s(_vm.$t("UnitGroupDetail.deleteTitle"))),
                      ]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", dark: "" },
                          on: {
                            click: function ($event) {
                              _vm.removeUnitDialog = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _vm._v(_vm._s(_vm.$t("UnitGroupDetail.deleteMsg"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "delete", dark: "" },
                          on: {
                            click: function ($event) {
                              return _vm.removeUnitFromGroup()
                            },
                          },
                        },
                        [
                          _c("v-icon", [_vm._v("delete_forever")]),
                          _vm._v(
                            _vm._s(_vm.$t("Button.Remove")) + "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary", outline: "" },
                          on: {
                            click: function ($event) {
                              _vm.removeUnitDialog = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "800" },
              model: {
                value: _vm.editCovertDialog,
                callback: function ($$v) {
                  _vm.editCovertDialog = $$v
                },
                expression: "editCovertDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dense: "", dark: "", color: "primary" } },
                    [
                      _c("v-toolbar-title", [
                        _vm._v(_vm._s(_vm.$t("UnitGroupDetail.editTitle"))),
                      ]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", dark: "" },
                          on: {
                            click: function ($event) {
                              _vm.editCovertDialog = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "pl-3": "", "pr-3": "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "From Unit",
                                  value: _vm.formulaData.FromUnit,
                                  disabled: "",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  label: "To Unit",
                                  value: _vm.formulaData.ToUnit,
                                  disabled: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "", "pl-3": "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Formula",
                                  value: _vm.prefix,
                                  disabled: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "pr-3": "" } },
                            [
                              _c("HighlightTextField", {
                                model: {
                                  value: _vm.formulaData.Formula,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formulaData, "Formula", $$v)
                                  },
                                  expression: "formulaData.Formula",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "add", dark: "" },
                          on: {
                            click: function ($event) {
                              return _vm.updateCovert()
                            },
                          },
                        },
                        [
                          _c("v-icon", [_vm._v("done")]),
                          _vm._v(
                            _vm._s(_vm.$t("Button.Save")) + "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary", outline: "" },
                          on: {
                            click: function ($event) {
                              return _vm.closeDialog()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { color: "grey lighten-4" } },
        [
          _c(
            "v-snackbar",
            {
              staticStyle: { "text-align": "left" },
              attrs: {
                "auto-height": "",
                color: _vm.snackbar.snackbarColor,
                timeout: null,
                top: "",
              },
              model: {
                value: _vm.snackbar.isSnackbarShow,
                callback: function ($$v) {
                  _vm.$set(_vm.snackbar, "isSnackbarShow", $$v)
                },
                expression: "snackbar.isSnackbarShow",
              },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.snackbar.snackbarMessage) + "\n      "
              ),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.hideSnackbar()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }